module.exports = __webpack_public_path__ + "img/customerService.0dda1fd4.svg";